import type { SaveDialogProps } from "./types-save-filter-dialog";
import { useFilterPanelSaveDialog } from "./use-save-filter-dialog";
import { FilterPanelSaveDialogView } from "./view-save-filter-dialog";

/** Diálogo "Salvar filtro" sobre o `Dialog`: nome validado em tela; a persistência é da tela (`onSave`). */
export function FilterPanelSaveDialog(props: SaveDialogProps) {
  const viewModel = useFilterPanelSaveDialog(props);

  return <FilterPanelSaveDialogView {...viewModel} />;
}
FilterPanelSaveDialog.displayName = "FilterPanel.SaveDialog";
